import { Controller } from '@hotwired/stimulus';

export default class FieldsetToggleController extends Controller {
  public static readonly targets = ['panel', 'radio'];

  declare public readonly panelTargets: HTMLElement[];
  declare public readonly radioTargets: HTMLInputElement[];

  public connect(): void {
    this.toggle();
  }

  public toggle(): void {
    const selectedValue = this._selectedValue;

    this.panelTargets.forEach(panel => {
      const active = panel.dataset.fieldsetToggleValue === selectedValue;

      panel.classList.toggle('d-none', !active);
      panel
        .querySelectorAll<
          HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >('input, select, textarea')
        .forEach(input => {
          input.disabled = !active;
        });
    });
  }

  private get _selectedValue(): string {
    const checkedRadio = this.radioTargets.find(radio => radio.checked);
    const [fallbackRadio] = this.radioTargets;

    return (checkedRadio ?? fallbackRadio).value;
  }
}
